import { createAsyncThunk } from "@reduxjs/toolkit";
// Utilities
import HttpClient from 'utilities/HttpClient';
import { getContent } from "utilities/Utilities";

const { accountId } = getContent('settings');

export default class SubscriptionsAsync {
  private static _url:string = '/client/subscriptions';
  private static _http:HttpClient = new HttpClient();

  // Cancel subscription
  public static cancelSubscription = createAsyncThunk('subscriptions/cancelSubscription', async (subscriptionId:any, thunkApi) => {
    const response:Response = await this._http.put(`${this._url}/${subscriptionId}/actions/cancel`, null);
    if ( !response.ok ) return thunkApi.rejectWithValue(({...await response.json(), status: response.status}) as any);
    return response.json();
  });

  // Fetch subscription package
  public static fetchSubscriptionPackages = createAsyncThunk('subscription/fetchSubscriptionPackages', async (_:any, thunkApi) => {
    const response:Response = await this._http.get(`${this._url}/packages`, { accountId });
    if ( !response.ok ) return thunkApi.rejectWithValue(({...await response.json(), status: response.status}) as any);
    return response.json();
  });

  // Create Subscription
  public static createSubscription = createAsyncThunk('subscriptions/createSubscription', async (data:any, thunkApi) => {
    const response:Response = await this._http.post(this._url, data);
    if ( !response.ok ) return thunkApi.rejectWithValue(({...await response.json(), status: response.status}) as any);
  });
}
